import avatar1 from '../images/avatar/avatar-1.jpg';
import avatar2 from '../images/avatar/avatar-2.jpg';
import avatar3 from '../images/avatar/avatar-3.jpg';
import avatar4 from '../images/avatar/avatar-4.jpg';



const ReviewsDB = [
  {
    description: 'The first week I was just dabbling, then I realised that it was possible \n' +
      'to win so much money here. Now I\'m withdrawing more and more money each time, but I try not to get carried away and have fun playing Coin Rush!\n' +
      'The site is simple and straightforward, no need to play around and understand everything intuitively. The odds are great',
    avatar: avatar1,
    name:'Cory'
  },
  {
    description: 'The first week I was just dabbling, then I realised that it was possible \n' +
      'to win so much money here. Now I\'m withdrawing more and more money each time, but I try not to get carried away and have fun playing Coin Rush!\n' +
      'The site is simple and straightforward, no need to play around and understand everything intuitively. The odds are great',
    avatar: avatar2,
    name:'Cory'
  },
  {
    description: 'The first week I was just dabbling, then I realised that it was possible \n' +
      'to win so much money here. Now I\'m withdrawing more and more money each time, but I try not to get carried away and have fun playing Coin Rush!\n' +
      'The site is simple and straightforward, no need to play around and understand everything intuitively. The odds are great',
    avatar: avatar3,
    name:'Cory'
  },
  {
    description: 'The first week I was just dabbling, then I realised that it was possible \n' +
      'to win so much money here. Now I\'m withdrawing more and more money each time, but I try not to get carried away and have fun playing Coin Rush!\n' +
      'The site is simple and straightforward, no need to play around and understand everything intuitively. The odds are great',
    avatar: avatar4,
    name:'Cory'
  },
]

export default ReviewsDB;